import clsx from 'clsx'

import React from 'react'

import imgixClient from '@disco/api/imgixClient'

import AspectRatio from 'components/ui/aspect-ratio'
import Icon from 'components/ui/icon'

import styles from './index.module.css'

const getImageURL = (
  image: string | null | undefined,
): string | null | undefined => {
  if (image) {
    return imgixClient.buildURL(image, {
      w: 320,
      h: 320,
    })
  }

  return undefined
}

type Props = {
  color: string | null | undefined
  image?: string | null | undefined
  overlay?: React.ReactNode
  status?: React.ReactNode
  ratio?: number
  type?: 'shadow'
  noPadding?: boolean
}

/**
 * Library artwork component with customizable aspect ratio and shadow effects
 * @param color - Background color for the artwork when no image is provided
 * @param image - URL of the library artwork image
 * @param overlay - Optional overlay content to display on top
 * @param status - Optional status indicator to show below the artwork
 * @param ratio - Aspect ratio for the artwork (defaults to 1:1)
 * @param type - Visual style type, currently supports 'shadow'
 * @param noPadding - Remove the default top padding
 */
const LibraryArtwork = ({
  color,
  image,
  overlay,
  status,
  ratio,
  type,
  noPadding,
}: Props): React.ReactElement<'div'> => (
  <div
    className={clsx(styles.libraryArtwork, {
      [styles.libraryArtworkNoPadding]: noPadding,
    })}
  >
    <AspectRatio
      fill={!image ? color : undefined}
      image={getImageURL(image)}
      ratio={ratio || 1}
      type={type}
    >
      {!image && <Icon type="soundwave" width={48} height={48} />}
      {overlay}
    </AspectRatio>

    {status && <div className={styles.libraryArtworkStatus}>{status}</div>}
  </div>
)

export default LibraryArtwork
